import { mmFetchWithResponse } from './mmFetchWithResponse';

class FBMOrderIngestResultsEndpoint {
    constructor() {
        this.baseUrl = 'api/fbm/v1/ingestResults';
    }

    /**
     * Get the order ingest results for a given FBM account
     * @param {string} fbmAccountName - The FBM account name
     * @param {boolean} includeSuccess - Whether to include success results
     * @param {number} page - The page number
     * @param {number} pageSize - The page size
     * @returns {Promise<Object>} The order ingest results
     */
    async getOrderIngestResults(fbmAccountName, includeSuccess, page, pageSize) {
        const url = `${this.baseUrl}?fbmAccount=${fbmAccountName}&includeSuccess=${includeSuccess}&page=${page}&pageSize=${pageSize}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    }
}

export { FBMOrderIngestResultsEndpoint };
